import { Box, Skeleton } from "@mui/material";
import { PREBOARD_EXAM_CODE_TABLE_COLUMNS } from "../../../pages/PreboardExamPage/PreboardExamPage";

export const SkeletonPreboardExamCode = () => (
    <Box sx={{ overflowX: "auto", width: "100%" }}>
        {/* Table header skeleton */}
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: PREBOARD_EXAM_CODE_TABLE_COLUMNS,
                minWidth: "950px",
                px: 2,
                py: 1.5,
                border: "1px solid #ddd",
                backgroundColor: "#5840BA",
                color: "white",
                fontWeight: 600,
            }}
        >
            {Array.from({ length: 4 }).map((_, idx) => (
                <Skeleton
                    key={idx}
                    variant="text"
                    width="80%"
                    sx={{ bgcolor: "rgba(255,255,255,0.2)" }}
                />
            ))}
            <Box />
        </Box>

        {/* Accordion content skeleton (without toggle) */}
        {Array.from({ length: 3 }).map((_, idx) => (
            <Box
                key={idx}
                sx={{
                    minWidth: "950px",
                    borderBottom: "1px solid #eee",
                    backgroundColor: "#F6F6F6",
                    px: 2,
                    py: 1.5,
                    display: "grid",
                    gridTemplateColumns: "300px 200px 150px 260px",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                {/* Columns */}
                <Skeleton variant="text" width="90%" />
                <Skeleton variant="text" width="70%" />
                <Skeleton variant="text" width="50%" />

                {/* Action buttons */}
                <Box sx={{ display: "flex", gap: 1 }}>
                    <Skeleton variant="rectangular" width={80} height={30} />
                    <Skeleton variant="rectangular" width={50} height={30} />
                    <Skeleton variant="rectangular" width={50} height={30} />
                </Box>
            </Box>
        ))}
    </Box>
)